import { PillarProps } from 'components/molecules/Pillar/types'
import React from 'react'
import PillarsSection from '../../sections/PillarsSection'
import { PillarsSliceProps } from './types'

const PillarsSlice: React.FC<PillarsSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { pi_title, pi_is_main_heading } = primary || {}

  return (
    <PillarsSection
      heading={pi_title?.text}
      isMainHeading={pi_is_main_heading}
      headingPadding={['60px', '', '88px']}
      inner="inners.primary"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['80px', '', '50px']}
      data={items.reduce((data, item, index) => {
        const { pi_item_title, pi_item_description, pi_item_icon } = item || {}

        if (!pi_item_icon) {
          return data
        }

        return [
          ...data,
          {
            key: `pillars-item-${index}`,
            icon: pi_item_icon,
            title: pi_item_title?.text || '',
            content: pi_item_description?.text || ''
          }
        ]
      }, [] as PillarProps[])}
      bgColor="#F8FAFF"
    />
  )
}

export default PillarsSlice
